<!-- Vue component -->
<template>
    <div>
        <label class="typo__label">{{ label }}</label>
        <multiselect v-model="value" :placeholder="placeholderMessage" label="name" track-by="id" :options="options" :multiple="true" :taggable="true" @input='onChange'></multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'cell large-12'
    },
    id: {
      type: String,
      default: function () {
        return 'input-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    required: {
      type: [Boolean, Number],
      default: false
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    values: {
      type: Array,
      default: function () {
        return []
      }
    },
    onLoadCallback: {
      type: Function,
      required: false
    },
    placeholderMessage: {
      type: String,
      default: null,
      required: false
    },
    model: {
      prop: 'modelValue',
      event: 'multiselectChanged'
    }
  },
  data () {
    return {
      value: [],
      options: []
    }
  },
  created () {
    if (this.items) {
      this.options = this._.clone(this.items)
    }

    if (this.values) {
      this.value = this.values.map(({ id, Name }) => ({ id: id, name: Name }))
    }
  },
  watch: {
    items: function () {
      this.options = this._.clone(this.items)
    }
  },
  methods: {
    onChange (value, id) {
      console.log(value)
      console.log(id)
      this.$emit('multiselectChanged', value)
    }
  }
}
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/Inputs/MultiSelectInput.vue